import { css } from 'styled-components'

const variables = css`
  :root {
    --text: #c1c1c1;
    --title: #f8f8fa;
    --white: #f8f8fa;
    --grey: #efefef;
    --grey-light: #cccccc;
    --grey-medium: #666666;
    --grey-hover: #3a3a3a;
    --black: #181818;
    --black-trans: rgba(24, 24, 24, 0.75);
    --black-dark: #1a1b1c;
    --black-medium: #1d1e1f;
    --black-light: #212121;
    --border-dark: #555555;
    --border-light: #dddddd;
    --secondary: #f0738f;
    --error: #f0738f;
    --service-design: #d5c327;
    --service-development: #5f8e3f;
    --service-marketing: #61aff0;
    --service-support: #5c2061;
    --grey-hover-shadow: rgba(37, 47, 56, 0.25);

    --font-sans: 'Inter', sans-serif;
    --font-condensed: 'Barlow', sans-serif;
    --fz-xxs: 12px;
    --fz-xs: 14px;
    --fz-sm: 16px;
    --fz-md: 18px;
    --fz-lg: 20px;
    --fz-xl: 30px;
    --fz-xxl: 42px;
    --max-width: 1200px;
    --max-inner: 720px;
    --transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
    --hamburger-width: 30px;
    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`

export default variables
